import React from 'react';

const ExperienceIcon = () => {
      return (
            <>
                  <span className="material-symbols-outlined">
                        travel_explore
                  </span>
            </>
      );
};

export default ExperienceIcon;
